import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import RazorpayCheckout from "./RazorpayCheckout";
import Device from 'react-device'


function App() {
  const [os, setOs] = useState(undefined)

  const onChange = (deviceInfo) => {
    console.log('Os', deviceInfo?.os?.name)
    setOs(deviceInfo?.os?.name)
  }
  return (
    // <Device onChange={onChange}>
    <Router>
      <Routes>
        {/* Directly open checkout when visiting /:orderId */}
        <Route path="/:orderId/:data" element={<RazorpayCheckout/>} />
      </Routes>
    </Router>
    // </Device>
  );
}

export default App;
